<div class="qm-card-container" fxLayout="row" fxLayoutAlign="center center">
  <mat-card class="qm-card">
    <div class="container container-form">
      <form>
        <div class="row">
          <div class="col-xl-6 col-md-6 col-sm-12">
            <mat-form-field class="input-full-width">
              <mat-label>Tipo de PMS (*)</mat-label>
              <mat-select
                (selectionChange)="checkFields()"
                [(ngModel)]="
                  cardEncoderSetting?.cardEncodeSettings.cardEncodeType
                "
                name="cardEncodeType"
              >
                <mat-option
                  *ngFor="let cardEncodeType of cardEncodeTypes"
                  [value]="cardEncodeType.value"
                >
                  {{ cardEncodeType.name }}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>
          <div class="col-xl-6 col-md-6 col-sm-12">
            <mat-form-field class="input-full-width">
              <mat-label>Subempresa</mat-label>
              <mat-select
                [(ngModel)]="
                  cardEncoderSetting?.cardEncodeSettings.subcompanyId
                "
                (selectionChange)="checkFields()"
                name="subcompanyId"
              >
                <mat-option
                  *ngFor="let subcompany of subcompanies"
                  [value]="subcompany.id"
                >
                  {{ subcompany.name }}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>
        </div>

        <div class="row">
          <div class="col-xl-6 col-md-6 col-sm-12">
            <mat-form-field class="input-full-width">
              <mat-label>URL do Integrador (*)</mat-label>
              <input
                matInput
                (keyup)="checkFields()"
                [(ngModel)]="
                  cardEncoderSetting?.cardEncodeSettings.integratorApiUrl
                "
                name="integratorApiUrl"
              />
            </mat-form-field>
          </div>
          <div class="col-xl-6 col-md-6 col-sm-12">
            <mat-form-field class="input-full-width">
              <mat-label>LicenseKeyValidator da API dos Encoders (*)</mat-label>
              <input
                matInput
                (keyup)="checkFields()"
                [(ngModel)]="
                  cardEncoderSetting?.cardEncodeSettings.integratorApiLicenseKeyValidator
                "
                name="integratorApiLicenseKeyValidator"
              />
            </mat-form-field>
          </div>
        </div>

        <div class="row">
          <div class="col-xl-6 col-md-6 col-sm-12">
            <mat-form-field class="input-full-width">
              <mat-label>URL da API dos Encoders (*)</mat-label>
              <input
                matInput
                (keyup)="checkFields()"
                [(ngModel)]="
                  cardEncoderSetting?.cardEncodeSettings.cardEncoderUrl
                "
                name="cardEncoderUrl"
              />
            </mat-form-field>
          </div>
          <div class="col-xl-6 col-md-6 col-sm-12">
            <mat-form-field class="input-full-width">
              <mat-label
                >Token de Autenticação da API dos Encoders (*)</mat-label
              >
              <input
                matInput
                (keyup)="checkFields()"
                [(ngModel)]="
                  cardEncoderSetting?.cardEncodeSettings.cardEncoderAuthToken
                "
                name="cardEncoderAuthToken"
              />
            </mat-form-field>
          </div>
        </div>
      </form>
    </div>

    <div class="row row-footer">
      <div class="container">
        <div class="row">
          <div class="col-6">
            <button
              class="form-button button-form-ptt"
              (click)="goBack()"
              mat-raised-button
              color="accent"
            >
              <mat-icon aria-hidden="false">arrow_back</mat-icon>
              VOLTAR
            </button>
          </div>
          <div class="col-6 align-right">
            <button
              class="form-button button-form-ptt"
              (click)="saveData()"
              [disabled]="!enableSave"
              mat-raised-button
              color="accent"
            >
              <mat-icon aria-hidden="false">save</mat-icon>
              GRAVAR
            </button>
          </div>
        </div>
      </div>
    </div>
  </mat-card>
</div>
